<template>
  <ComingConsultationsPage method="chat" />
</template>

<script setup>
import ComingConsultationsPage from "./ComingConsultationsPage.vue";
</script>
